import { ref } from 'vue'

const values = {}

const getItem = (key, defaultValue = null, storage) => {
  let value = storage.getItem(key)
  if (!value) {
    return defaultValue
  }
  try {
    return JSON.parse(value)
  } catch (error) {
    return value
  }
}

export const useStorage = (key, defaultValue = null, type = 'session') => {
  let storage = null
  switch (type) {
    case 'session':
      storage = sessionStorage
      break
    case 'local':
      storage = localStorage
      break
    default:
      throw 'Uknown storage'
  }

  if (!values[key + storage]) {
    values[key + storage] = ref(getItem(key, defaultValue, storage))
  }

  const value = values[key + storage]

  const setItem = storage => {
    return newValue => {
      value.value = newValue
      storage.setItem(key, JSON.stringify(newValue))
    }
  }
  return [value, setItem(storage)]
}
